import { render } from "./AISummaryCopilot.vue?vue&type=template&id=0c656306"
import script from "./AISummaryCopilot.vue?vue&type=script&lang=js"
export * from "./AISummaryCopilot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__